import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown, Search } from 'lucide-react';
import NotificationBell from './NotificationBell';

const EditorialNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  
  const isActive = (path) => location.pathname === path;
  
  const navLinks = [
    { path: '/about', label: 'about' },
    { path: '/news', label: 'news' },
    { path: '/contact', label: 'contact' },
  ];

  return (
    <nav className="nav-header">
      <div className="nav-container">
        {/* Logo */}
        <Link to="/" className="flex items-center font-black text-xl tracking-tight text-black uppercase">
          BGN
        </Link>

        {/* Desktop Navigation */}
        <div className="nav-menu">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${isActive(link.path) ? 'text-black' : ''}`}
            >
              {link.label}
              <ChevronDown className="nav-link-dropdown" />
            </Link>
          ))}
          
          {/* Search Link */}
          <Link to="/search" className={`nav-link ${isActive('/search') ? 'text-black' : ''}`} aria-label="Search streamers">
            <Search size={16} />
          </Link>

          {/* Notification Bell */}
          <NotificationBell />

          {/* Account Link */}
          <Link to="/account" className="nav-account">
            my account
          </Link>
        </div>

        {/* Mobile menu button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="mobile-menu-button"
          aria-label="Toggle menu"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="fixed inset-0 top-16 bg-white z-50 p-4 md:hidden">
          <div className="flex flex-col space-y-6 pt-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`text-2xl font-light ${
                  isActive(link.path) ? 'text-black' : 'text-gray-600'
                }`}
              >
                {link.label}
              </Link>
            ))}
            
            <Link
              to="/search"
              onClick={() => setIsOpen(false)}
              className={`text-2xl font-light ${isActive('/search') ? 'text-black' : 'text-gray-600'}`}
            >
              find streamers
            </Link>

            <Link
              to="/account"
              onClick={() => setIsOpen(false)}
              className="bg-black text-white px-6 py-3 text-center font-light w-fit"
            >
              my account
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default EditorialNavbar;